import React from 'react';
import GetAppButton from 'containers/CVLandingPage/CVPromoSection/GetAppButton';
import PageTitleBar from 'components/PageTitleBar';
import { LG_BREAKPOINT_AND_UP } from 'utils/constants';
import useMediaQuery from 'utils/useMediaQuery';
import CasinoverseIcon from './assets/Casinoverse.png';
import QRCode from './assets/QR-500.png';
import './CasinoversePage.css';

const generateTextBlock = [
  {
    head: 'Endless Fun',
    body: 'More WScore & gems with exclusive games & activities'
  },
  {
    head: 'Enhanced Rewards',
    body: 'Exchange Wscore & gems for better offers'
  },
  {
    head: 'Easy Redemption',
    body: 'Enjoy your rewards at your favorite Wind Creek Property'
  }
];

function CasinoversePage(props) {
  const isDesktop = useMediaQuery(LG_BREAKPOINT_AND_UP);

  const textContent = generateTextBlock.map((text, index) => {
    return (
      <div className="content-wrapper" key={index}>
        <div className="content-title">{text.head}</div>
        <div className="content-body">{text.body}</div>
      </div>
    );
  });

  return (
    <div className="casinoverse-page-container">
      <PageTitleBar title="Casinoverse" icon={CasinoverseIcon} />
      {isDesktop ? (
        <div className="container-body">
          <div className="left-panel">
            <div className="main-heading">
              Upgrade to experience our evolution of fun and rewards!
            </div>
            {textContent}
          </div>
          <div className="right-panel">
            <div className="app-info-container">
              <div className="cv-qr-code">
                <img src={QRCode} alt={'QR-Code'} />
                <span className="qr-subtext"> Get app on mobile </span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="container-body">
          <div className="left-panel">
            <div className="main-heading">
              Upgrade to experience our evolution of fun and rewards!
            </div>
            <div className="right-panel" />
            <div className="get-app-button-wrapper">
              {GetAppButton({ isBox: true })}
            </div>
            {textContent}
          </div>
        </div>
      )}
    </div>
  );
}

export default CasinoversePage;
